import {
  DEFAULT_GRID_PREFERENCE,
  sanitizeGridPreference,
  applyColumnOrder,
  JobsColumnsPopover,
} from '../jobs/JobsColumnsHelper';

export const GRID_PREFERENCES_STORAGE_KEY = 'requestsGridPreferences';
export const SECTION_HEIGHTS_STORAGE_KEY = 'requestsSectionHeights';

export const DEFAULT_SECTION_HEIGHT = 400;
export const MIN_SECTION_HEIGHT = 200;
export const MAX_SECTION_HEIGHT = 900;

export const REQUEST_SECTION_KEYS = [
  'myRequests',
  'clientRequests',
  'jobUnlockRequests',
  'technicianRequests',
  'partRequests',
  'proposalRequests',
];

export { DEFAULT_GRID_PREFERENCE, sanitizeGridPreference, applyColumnOrder };
export const RequestsColumnsPopover = JobsColumnsPopover;

export const parseGridPreferences = () => {
  const stored = window.localStorage.getItem(GRID_PREFERENCES_STORAGE_KEY);
  if (!stored) {
    return {};
  }

  try {
    const parsed = JSON.parse(stored);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

export const parseSectionHeights = () => {
  const stored = window.localStorage.getItem(SECTION_HEIGHTS_STORAGE_KEY);
  if (!stored) {
    return {};
  }

  try {
    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== 'object') return {};

    return REQUEST_SECTION_KEYS.reduce((acc, key) => {
      const value = Number(parsed[key]);
      if (Number.isFinite(value)) {
        acc[key] = Math.min(MAX_SECTION_HEIGHT, Math.max(MIN_SECTION_HEIGHT, value));
      }
      return acc;
    }, {});
  } catch {
    return {};
  }
};

export const clampSectionHeight = (height) => {
  const value = Number(height);
  if (!Number.isFinite(value)) return DEFAULT_SECTION_HEIGHT;
  return Math.min(MAX_SECTION_HEIGHT, Math.max(MIN_SECTION_HEIGHT, value));
};
